/*
  MODI wishlist - 2026-08-04

  localStorage only: the store is on Basic, no wishlist app is installed and customer
  accounts are optional, so requiring a login to save a product would lose most of the
  value. Every affordance is injected at runtime onto existing markup, which is why no
  Liquid card/button template had to be rewritten. None of this is content a crawler
  needs, so the JS-only dependency costs nothing in SEO terms.
*/
(function () {
  'use strict';

  var KEY = 'modi_wishlist_v1';
  var MAX = 200;
  var EAGER_ROWS = 8;
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var IS_KA = (document.documentElement.lang || '').toLowerCase().indexOf('ka') === 0;

  var T = IS_KA ? {
    add: 'სურვილების სიაში დამატება',
    remove: 'სურვილების სიიდან ამოშლა',
    nav: 'სურვილების სია',
    count1: '1 პროდუქტი',
    countN: '{n} პროდუქტი',
    clear: 'ყველას გასუფთავება',
    clearConfirm: 'ნამდვილად გსურთ სიიდან ყველა პროდუქტის წაშლა?',
    emptyTitle: 'სურვილების სია ცარიელია',
    emptyText: 'მოგწონთ რამე? დააჭირეთ გულის ნიშანს პროდუქტზე და აქ შეინახება.',
    browse: 'კატალოგის ნახვა',
    soldOut: 'არ არის მარაგში',
    toCart: 'კალათაში დამატება',
    choose: 'ვარიანტის არცევა',
    added: 'დაემატა ✓',
    failed: 'ვერ დაემატა',
    loadFailTitle: 'ვერ ჩაიტვირთა',
    loadFailN: '{n} პროდუქტი ვერ ჩაიტვირთა — ქსელის შეცდომა. სიიდან არ წაშლილა.',
    retry: 'ხელახლა ცდა'
  } : {
    add: 'Add to wishlist',
    remove: 'Remove from wishlist',
    nav: 'Wishlist',
    count1: '1 product',
    countN: '{n} products',
    clear: 'Clear all',
    clearConfirm: 'Remove every product from the wishlist?',
    emptyTitle: 'Your wishlist is empty',
    emptyText: 'Like something? Tap the heart on a product and it will be saved here.',
    browse: 'Browse the catalogue',
    soldOut: 'Sold out',
    toCart: 'Add to cart',
    choose: 'Choose options',
    added: 'Added ✓',
    failed: 'Could not add',
    loadFailTitle: 'Could not load',
    loadFailN: '{n} product(s) could not be loaded — network error. They are still saved.',
    retry: 'Try again'
  };

  // Drawn to fill the 24 viewBox: ink spans x 2-22, y 3-21. The previous, daintier path
  // measured 14.4x12.6px against the theme bag icon's 16.1x15.5px in the same 20px box,
  // which read as "the heart is smaller than the cart" in the header. Stroke width is set
  // in CSS (1.6 on a 24 viewBox = the same 1.33px line as the bag's 1 on its 15 viewBox).
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" stroke-linejoin="round"/></svg>';

  /* ---------- store ---------- */

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function write(list) {
    save(list);
    document.dispatchEvent(new CustomEvent('modi:wishlist'));
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  /* ---------- helpers ---------- */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function handleFromUrl(href) {
    if (!href) return null;
    var m = href.split('?')[0].split('#')[0].match(/\/products\/([^/]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  // /products/{handle}.js already returns a locale-prefixed url on non-default locales
  // (on /en it hands back "/en/products/x"), so blindly prepending ROOT produced /en/en/.
  function localeUrl(path) {
    if (!path) return ROOT + '/';
    return path.indexOf(ROOT + '/') === 0 ? path : ROOT + path;
  }

  function money(cents) {
    var fmt = window.MODI_MONEY_FORMAT || '{{amount}} GEL';
    var withDec = (cents / 100).toFixed(2);
    var noDec = String(Math.round(cents / 100));
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
  }

  function button(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls + ' expand-link--ignore';
    b.setAttribute('data-modi-wl', handle);
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', T.add);
    b.innerHTML = HEART;
    return b;
  }

  /* ---------- hydration ---------- */

  function hydrateCards() {
    var cards = document.querySelectorAll('.card-product:not([data-wl-ready])');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      card.setAttribute('data-wl-ready', '1');
      if (card.classList.contains('card-product--placeholder')) continue;
      var link = card.querySelector('a.expand-link__link[href]');
      var media = card.querySelector('.card__media-wrapper');
      if (!link || !media) continue;
      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) continue;
      media.appendChild(button(handle, 'modi-wl__btn'));
    }
  }

  function hydratePdp() {
    var handle = handleFromUrl(location.pathname);
    if (!handle) return;
    var groups = document.querySelectorAll('.buy-buttons__buttons');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      // the sticky add-to-cart bar repeats this container; only the main form gets a button
      if (g.closest('sticky-add-to-cart')) continue;
      if (g.getAttribute('data-wl-ready')) continue;
      g.setAttribute('data-wl-ready', '1');
      var b = button(handle, 'modi-wl__pdp');
      var label = document.createElement('span');
      label.className = 'modi-wl__pdp-label';
      label.textContent = T.add;
      b.appendChild(label);
      g.insertAdjacentElement('afterend', b);
    }
  }

  // The theme's own .header__secondary-item class is what carries the icon padding, in BOTH
  // the desktop list and the mobile icon row (the mobile cart uses it too). Without it the
  // anchor rendered 22x31 desktop / 28x32 mobile next to 35x40 and 32x36 siblings.
  function navLink() {
    var a = document.createElement('a');
    a.href = ROOT + '/pages/wishlist';
    a.className = 'modi-wl__nav header__secondary-item';
    a.setAttribute('aria-label', T.nav);
    a.setAttribute('data-on', '0');
    a.innerHTML = HEART + '<span class="modi-wl__count" aria-hidden="true"><span></span></span>';
    return a;
  }

  function hydrateNav() {
    var list = document.querySelector('.header__secondary-menu-list');
    if (list && !list.querySelector('.modi-wl__nav')) {
      var li = document.createElement('li');
      li.className = 'header__secondary-list-item';
      li.appendChild(navLink());
      var cart = list.querySelector('.header__cart-button');
      var cartLi = cart ? cart.closest('li') : null;
      if (cartLi) { list.insertBefore(li, cartLi); } else { list.appendChild(li); }
    }
    var mob = document.querySelector('.header__mobile-icons');
    if (mob && !mob.querySelector('.modi-wl__nav')) {
      var mcart = mob.querySelector('.header__cart-button');
      var anchor = mcart ? (mcart.closest('dialog-trigger') || mcart) : null;
      if (anchor) { mob.insertBefore(navLink(), anchor); } else { mob.appendChild(navLink()); }
    }
  }

  /* ---------- wishlist page ---------- */

  var cache = {};
  var lastKey = null;

  // 2026-09-06: a handle whose fetch FAILED is not a handle whose product is gone. Marking
  // the failure keeps it out of the prune list below; the row reuses the empty-state classes
  // (modi-wishlist.css) so no stylesheet had to change to show it.
  var FAILED = {};

  function failedHtml(n) {
    return '<div class="modi-wl__empty">' +
      '<div class="modi-wl__empty-title">' + esc(T.loadFailTitle) + '</div>' +
      '<div class="modi-wl__empty-text">' + esc(T.loadFailN.replace('{n}', n)) + '</div>' +
      '<button type="button" class="button button--primary" data-wl-retry>' + esc(T.retry) + '</button>' +
      '</div>';
  }

  function emptyHtml() {
    return '<div class="modi-wl__empty">' + HEART +
      '<div class="modi-wl__empty-title">' + esc(T.emptyTitle) + '</div>' +
      '<div class="modi-wl__empty-text">' + esc(T.emptyText) + '</div>' +
      '<a class="button button--primary" href="' + ROOT + '/collections/all">' + esc(T.browse) + '</a>' +
      '</div>';
  }

  function cardHtml(p, i) {
    var url = localeUrl(p.url);
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var src = img ? img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600' : '';
    // On a wishlist the images ARE the content and the list is short, so the first rows
    // load eagerly instead of waiting on an intersection observer.
    var eager = i < EAGER_ROWS;
    var multi = p.variants && p.variants.length > 1;
    var btn = !p.available
      ? '<button type="button" class="modi-wlp__add" disabled>' + esc(T.soldOut) + '</button>'
      : '<button type="button" class="modi-wlp__add" data-wl-add="' + esc(p.handle) + '">' +
          esc(multi ? T.choose : T.toCart) + '</button>';

    return '<div class="modi-wlp__card">' +
      '<a class="modi-wlp__media" href="' + esc(url) + '">' +
        (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '"' +
               ' loading="' + (eager ? 'eager' : 'lazy') + '"' +
               ' fetchpriority="' + (eager ? 'high' : 'low') + '"' +
               ' width="600" height="600">' : '') +
      '</a>' +
      '<button type="button" class="modi-wlp__rm" data-modi-wl="' + esc(p.handle) + '"' +
        ' aria-label="' + esc(T.remove) + '" title="' + esc(T.remove) + '">' + HEART + '</button>' +
      '<a class="modi-wlp__t" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
      '<div class="modi-wlp__p' + (p.available ? '' : ' modi-wlp__p--out') + '">' +
        (p.available ? esc(money(p.price)) : esc(T.soldOut)) +
      '</div>' + btn +
    '</div>';
  }

  function headHtml(n) {
    var label = n === 1 ? T.count1 : T.countN.replace('{n}', n);
    return '<div class="modi-wlp__head">' +
      '<span class="modi-wlp__n">' + esc(label) + '</span>' +
      '<button type="button" class="modi-wlp__clear" data-wl-clear>' + esc(T.clear) + '</button>' +
      '</div>';
  }

  function renderPage(force) {
    var box = document.querySelector('[data-modi-wl-page]');
    if (!box) return;
    var list = read();
    var key = list.join('|');
    // Rewriting innerHTML on every sync would destroy the very button the user is pressing
    // between mousedown and mouseup, so only re-render when the set actually changed.
    if (!force && key === lastKey) return;
    lastKey = key;

    if (!list.length) { box.innerHTML = emptyHtml(); return; }

    // 2026-09-06: every non-2xx and every rejected request used to collapse to the same null
    // as a deleted product, so one bad mobile moment (or a 429 from Shopify) classified the
    // whole set as dead and save() wrote the survivors — none — back over the customer's list.
    // It is localStorage only: no account sync, no app, no undo. Only 404/410 is Shopify
    // saying the product is gone; anything else keeps the handle and offers a retry.
    Promise.all(list.map(function (h) {
      if (Object.prototype.hasOwnProperty.call(cache, h)) return Promise.resolve(cache[h]);
      return fetch(ROOT + '/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) {
          if (r.ok) {
            return r.json().then(function (p) { cache[h] = p; return p; }, function () { return FAILED; });
          }
          if (r.status === 404 || r.status === 410) { cache[h] = null; return null; }
          return FAILED;
        })
        .catch(function () { return FAILED; });
    })).then(function (items) {
      // drop handles the shop positively said are gone (product deleted or unpublished)
      var dead = [];
      items.forEach(function (p, i) { if (p === null) dead.push(list[i]); });
      if (dead.length) {
        var kept = read().filter(function (h) { return dead.indexOf(h) === -1; });
        save(kept);
        lastKey = kept.join('|');
      }
      var failed = 0;
      items.forEach(function (p) { if (p === FAILED) failed++; });
      var good = items.filter(function (p) { return p && p !== FAILED; });
      box.innerHTML = good.length
        ? headHtml(good.length) + '<div class="modi-wlp">' + good.map(cardHtml).join('') + '</div>' +
          (failed ? failedHtml(failed) : '')
        : (failed ? failedHtml(failed) : emptyHtml());
      // lastKey is deliberately NOT cleared here: box.innerHTML wakes the MutationObserver,
      // which calls renderPage again, and on a lasting outage that would refetch forever. The
      // failed handles are simply not cached, so the retry button's renderPage(true) refetches.
      syncCounts();
    });
  }

  /* ---------- cart ---------- */

  // The cart badge and drawer live in Liquid sections, so a bare /cart/add.js leaves them
  // showing stale markup until the next page load. Ask Shopify to re-render those sections
  // with the add and swap them in, which is how the theme's own forms stay in sync.
  function cartSectionIds() {
    var ids = [];
    var els = document.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < els.length; i++) {
      var id = els[i].id.replace('shopify-section-', '');
      if (/__cart-drawer$|__header$/.test(id)) ids.push(id);
    }
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var el = document.getElementById('shopify-section-' + id);
      if (!el || typeof sections[id] !== 'string') return;
      try {
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        el.innerHTML = fresh ? fresh.innerHTML : sections[id];
      } catch (e) {}
    });
  }

  // The mobile bottom bar is a snippet, not a section, so the theme never refreshes it -
  // its count stayed one step behind the header until a reload. Writes are guarded so this
  // does not re-trigger the MutationObserver that calls it.
  function mobileNavBadge(n) {
    var wrap = document.querySelector('.mobile-nav__cart-wrap');
    if (!wrap) return;
    var b = wrap.querySelector('.mobile-nav__badge');
    if (n > 0) {
      if (!b) {
        b = document.createElement('span');
        b.className = 'mobile-nav__badge';
        b.setAttribute('data-cart-count', '');
        b.innerHTML = '<span></span>';
        wrap.appendChild(b);
      }
      var target = b.querySelector('span') || b;
      if (target.textContent !== String(n)) target.textContent = String(n);
    } else if (b) {
      b.remove();
    }
  }

  // Mirror whatever the header badge shows. Reading the header rather than fetching
  // /cart.js means this also catches adds made by the theme's own product form, not just
  // the ones made from the wishlist page.
  function mirrorCartCount() {
    var src = document.querySelector('.header__cart-count[data-cart-count]');
    if (!src) { mobileNavBadge(0); return; }
    var n = parseInt((src.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (!isNaN(n)) mobileNavBadge(n);
  }

  function addToCart(handle, btn) {
    var p = cache[handle];
    if (!p) return;
    if (p.variants && p.variants.length > 1) { location.href = localeUrl(p.url); return; }
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return;
    btn.disabled = true;
    fetch(ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1 }],
        sections: cartSectionIds(),
        sections_url: location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (data) {
      applySections(data.sections);
      hydrateNav();      // the header section was just replaced, re-inject the wishlist icon
      mirrorCartCount();
      syncCounts();
      btn.classList.add('is-done');
      btn.textContent = T.added;
      setTimeout(function () {
        btn.classList.remove('is-done');
        btn.textContent = T.toCart;
        btn.disabled = false;
      }, 1800);
    }).catch(function () {
      btn.textContent = T.failed;
      setTimeout(function () { btn.textContent = T.toCart; btn.disabled = false; }, 1800);
    });
  }

  /* ---------- sync ---------- */

  function syncCounts() {
    var n = read().length;
    var counters = document.querySelectorAll('.modi-wl__count');
    for (var i = 0; i < counters.length; i++) {
      var inner = counters[i].querySelector('span') || counters[i];
      if (inner.textContent !== String(n)) inner.textContent = String(n);
      counters[i].classList.toggle('is-on', n > 0);
      var nav = counters[i].closest('.modi-wl__nav');
      // drives the phone-only rule that keeps the icon out of the header until it has content
      if (nav) nav.setAttribute('data-on', n > 0 ? '1' : '0');
    }
  }

  function sync() {
    var list = read();
    var btns = document.querySelectorAll('[data-modi-wl]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.classList.contains('modi-wlp__rm')) continue;
      var on = list.indexOf(b.getAttribute('data-modi-wl')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.remove : T.add);
      var lab = b.querySelector('.modi-wl__pdp-label');
      if (lab) lab.textContent = on ? T.remove : T.add;
    }
    syncCounts();
    renderPage();
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var clear = e.target.closest('[data-wl-clear]');
    if (clear) {
      e.preventDefault();
      if (window.confirm(T.clearConfirm)) { write([]); }
      return;
    }

    var again = e.target.closest('[data-wl-retry]');
    if (again) {
      e.preventDefault();
      renderPage(true);
      return;
    }

    var addBtn = e.target.closest('[data-wl-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn.getAttribute('data-wl-add'), addBtn);
      return;
    }

    // capture phase: the whole product card is wrapped in an expand-link overlay anchor,
    // so this has to run before the theme's own handler navigates away.
    var b = e.target.closest('[data-modi-wl]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.getAttribute('data-modi-wl'));
    if (added && b.classList.contains('modi-wl__btn')) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  }, true);

  document.addEventListener('modi:wishlist', sync);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { cache = {}; lastKey = null; sync(); }
  });

  var pending = false;
  function hydrate() {
    hydrateCards();
    hydratePdp();
    hydrateNav();
    mirrorCartCount();
    sync();
  }
  // setTimeout, NOT requestAnimationFrame: none of this work is paint-bound, and rAF is
  // paused in background tabs (and in some embedded webviews), which would silently stall
  // hydration of cards and the cart-count mirror until the tab was focused again.
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; hydrate(); }, 0);
  }

  function boot() {
    hydrate();
    // cards arrive later from infinite scroll, filtering and the quick-add modal, and the
    // theme swaps the header section on every cart change. hydrate() only touches nodes
    // without data-wl-ready, renderPage() is a no-op when the saved set has not changed and
    // the badge writers skip no-op writes, so this converges instead of looping.
    if ('MutationObserver' in window) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
